import React from 'react';
import {connect} from 'react-redux';

function StoreLoader(props) {
    const styleObj = {
        ...props.styleObj,
        display: props.showLoader ? 'block' : 'none'
    };
	const className = props.className || "";
	let extraProps = {};
	if(props.id){
		extraProps.id = props.id;
	}
    return (
		<div className={`mobile-loader ${className}`} {...extraProps} style={styleObj}
			onClick = {(e) => {
				e.stopPropagation();
			}}
		>
			<div className="svg-wrapper">
				<div className="circle"></div>
			</div>
		</div>
    );
}

const mapStateToProps = ({showLoader}, props) => ({
	...props,
	showLoader
});

export default connect(mapStateToProps, null)(StoreLoader);